import script from "./AgingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./AgingSummary.vue?vue&type=script&setup=true&lang=js"

import "./AgingSummary.vue?vue&type=style&index=0&id=580966db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580966db"]])

export default __exports__